import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  packageManagementData: [],
  totalPartnersInPackages: 0,
  isLoading: false,
  error: "",
};

export const PackageManagementSlice = createSlice({
  name: "PackageManagementData",
  initialState,
  reducers: {
    setPackageManagementData: (state, action) => {
      state.packageManagementData = action.payload.data.data;
      state.totalPartnersInPackages = action.payload.data.total;
    },
    clearPackageManagementData: (state) => {
      state.packageManagementData = [];
      state.error = "";
      state.isLoading = false;
    },
    catchError: (state, action) => {
      state.error =
        action.payload.message ||
        "un expected error while fetching PackageManagement data";
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setPackageManagementData,
  clearPackageManagementData,
  catchError,
  setLoading,
} = PackageManagementSlice.actions;
export default PackageManagementSlice.reducer;
